<div class="news-card-wrapper" [class.has-unclaimed-gift]="hasUnclaimedGift">
  <ng-container [ngSwitch]="newsItem.layout">
    <!-- Layout 1 -->
    <ng-container *ngSwitchCase="layouts.Layout1">
      <div class="w-100 news-item-layout news-item-layout-padding d-flex flex-row" data-testid="news-widget-item">
        <div class="news-item-l1-content d-flex flex-row">
          <div class="d-flex flex-column">
            <kh-badge-dot class="seen-dot" *ngIf="!newsItem.seen"></kh-badge-dot>
            <div class="placeholder" *ngIf="newsItem.seen"></div>
          </div>
          <div class="d-flex flex-column">
            <div class="news-item-l1-title kh-title-md">
              {{ newsItem.subject }}
            </div>
            <div class="news-item-l1-description kh-body-sm" [innerHTML]="newsItem.shortDescription"></div>
          </div>
        </div>
        <div class="news-item-l1-image">
          <img
            class="w-100"
            [src]="newsItem.thumbnailImage"
            [alt]="'NEWS_WIDGET_ITEM.NEWS_IMAGE_ALT' | translate">
        </div>
      </div>
    </ng-container>

    <!-- Layout 2 -->
    <ng-container *ngSwitchCase="layouts.Layout2">
      <div class="w-100 news-item-layout d-flex flex-row" data-testid="news-widget-item">
        <div class="news-item-l2-image">
          <img
            class="w-100"
            [src]="newsItem.thumbnailImage"
            [alt]="'NEWS_WIDGET_ITEM.NEWS_IMAGE_ALT' | translate">
        </div>
        <div class="news-item-l2-content d-flex flex-row">
          <div class="d-flex flex-column">
            <kh-badge-dot class="seen-dot" *ngIf="!newsItem.seen"></kh-badge-dot>
            <div class="placeholder" *ngIf="newsItem.seen"></div>
          </div>
          <div class="d-flex flex-column">
            <div class="news-item-l2-title kh-title-md">
              {{ newsItem.subject }}
            </div>
            <div class="news-item-l2-description kh-body-sm" [innerHTML]="newsItem.shortDescription"></div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Layout 3 -->
    <ng-container *ngSwitchCase="layouts.Layout3">
      <div
        class="w-100 news-item-layout news-item-layout-padding news-item-layout-background d-flex flex-row"
        [style.backgroundImage]="'linear-gradient(90deg, #003676 50%, rgba(0, 54, 118, 0.00) 100%), url(' + newsItem.thumbnailImage + ')'"
        data-testid="news-widget-item">
        <div class="news-item-l3-content d-flex flex-row">
          <div class="d-flex flex-column">
            <kh-badge-dot class="seen-dot" *ngIf="!newsItem.seen"></kh-badge-dot>
            <div class="placeholder" *ngIf="newsItem.seen"></div>
          </div>
          <div class="d-flex flex-column">
            <div class="news-item-l3-title kh-title-md">
              {{ newsItem.subject }}
            </div>
            <div class="news-item-l3-description kh-body-sm" [innerHTML]="newsItem.shortDescription"></div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Layout 4 -->
    <ng-container *ngSwitchCase="layouts.Layout4">
      <div class="w-100 news-item-layout news-item-layout-padding d-flex flex-row" data-testid="news-widget-item">
        <div class="news-item-l4-content d-flex flex-row">
          <div class="d-flex flex-column">
            <kh-badge-dot class="seen-dot" *ngIf="!newsItem.seen"></kh-badge-dot>
            <div class="placeholder" *ngIf="newsItem.seen"></div>
          </div>
          <div class="d-flex flex-column">
            <div class="news-item-l4-title kh-title-md">
              {{ newsItem.subject }}
            </div>
            <div class="news-item-l4-description kh-body-sm" [innerHTML]="newsItem.shortDescription"></div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <div class="gift-badge" *ngIf="hasUnclaimedGift">
    <img
      class="gift-badge-triangle"
      src="https://staticcontent.knowledgehook.com/content/khg/ui/news-article/news-card-rectangle.svg"
      alt="">
    <img
      class="gift-badge-icon"
      src="https://staticcontent.knowledgehook.com/content/khg/ui/news-article/news-card-gift-icon.svg"
      alt="">
  </div>
</div>